"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_VARIANTS = exports.TEXT_TREATMENTS = exports.TEXT_LETTER_SPACING = exports.TEXT_LINE_HEIGHTS = exports.TEXT_FONT_SIZES = exports.TEXT_FONTS = void 0;

/**
 * font-families
 */
var TEXT_FONTS = {
  sans: '"ll-unica77", "Helvetica Neue", Helvetica, Arial, sans-serif',
  serif: '"adobe-garamond-pro", "Times New Roman", Times, serif'
};
/**
 * font-size scale
 */

exports.TEXT_FONTS = TEXT_FONTS;
var TEXT_FONT_SIZES = {
  size12: "62px",
  size11: "55px",
  size10: "48px",
  size9: "32px",
  size8: "28px",
  size7: "24px",
  size6: "18px",
  size5: "16px",
  size4: "15px",
  size3: "14px",
  size2: "13px",
  size1: "12px"
};
/**
 * Available font-sizes
 */

exports.TEXT_FONT_SIZES = TEXT_FONT_SIZES;

/**
 * line-height scale
 */
var TEXT_LINE_HEIGHTS = {
  solid: 1,
  title: 1.25,
  body: 1.5
};
/**
 * Available line-heights
 */

exports.TEXT_LINE_HEIGHTS = TEXT_LINE_HEIGHTS;

/**
 * letter-spacing scale
 */
var TEXT_LETTER_SPACING = {
  tight: "-0.02em",
  tightest: "-0.03em"
};
/**
 * Available letter-spacings
 */

exports.TEXT_LETTER_SPACING = TEXT_LETTER_SPACING;

/**
 * Names of typographic treatments
 */
var TEXT_TREATMENTS = ["largeTitle", "title", "subtitle", "text", "mediumText", "caption", "small"];
/**
 * TextTreatments
 */

exports.TEXT_TREATMENTS = TEXT_TREATMENTS;

/**
 * Available typographic treatments
 */
var TEXT_VARIANTS = {
  large: {
    largeTitle: {
      fontSize: "size9",
      lineHeight: "title",
      letterSpacing: "tight",
      fontWeight: "normal"
    },
    title: {
      fontSize: "size7",
      lineHeight: "title",
      letterSpacing: "tight",
      fontWeight: "normal"
    },
    subtitle: {
      fontSize: "size6",
      lineHeight: "title",
      fontWeight: "normal"
    },
    text: {
      fontSize: "size3",
      lineHeight: "body",
      fontWeight: "normal"
    },
    mediumText: {
      fontSize: "size3",
      lineHeight: "body",
      fontWeight: "bold"
    },
    caption: {
      fontSize: "size2",
      lineHeight: "body",
      fontWeight: "normal"
    },
    small: {
      fontSize: "size1",
      lineHeight: "body",
      fontWeight: "normal"
    }
  },
  small: {
    largeTitle: {
      fontSize: "size8",
      lineHeight: "title",
      letterSpacing: "tight",
      fontWeight: "normal"
    },
    title: {
      fontSize: "size6",
      lineHeight: "title",
      letterSpacing: "tight",
      fontWeight: "normal"
    },
    subtitle: {
      fontSize: "size5",
      lineHeight: "title",
      fontWeight: "normal"
    },
    text: {
      fontSize: "size4",
      lineHeight: "body",
      fontWeight: "normal"
    },
    mediumText: {
      fontSize: "size4",
      lineHeight: "body",
      fontWeight: "bold"
    },
    caption: {
      fontSize: "size3",
      lineHeight: "body",
      fontWeight: "normal"
    },
    small: {
      fontSize: "size2",
      lineHeight: "body",
      fontWeight: "normal"
    }
  }
};
/**
 * Name of typographic treatment
 */

exports.TEXT_VARIANTS = TEXT_VARIANTS;
//# sourceMappingURL=tokens.js.map